class MSG {
	static notLive = {
		de: {
			title: "Evaluation ist nicht aktiv",
			content:
				"Die von Ihnen angeforderte Evaluation ist zur Zeit nicht verfügbar. Das kann bedeuten, dass sie entweder noch nicht gestartet wurde oder bereits abgeschlossen ist. Falls Ihre Lehrperson keine weiteren Informationen hat, senden Sie uns bitte eine Nachricht an qualis@mx.uni-saarland.de.",
		},
		en: {
			title: "Evaluation is not active",
			content:
				"The evaluation you requested is not anvailable at the moment. This can either mean that it hasn't started yet or that it has already been finished. If your lecturer doesn't have any information, please send us a message to qualis@mx.uni-saarland.de.",
		},
	};
	static notFound = {
		de: {
			title: "Fehler",
			content:
				"Zu den angegebenen Daten konnte kein Fragebogen gefunden werden. Falls Sie den Fragebogen über einen Link aufgerufen haben, überprüfen Sie bitte, dass Sie wirklich den ganzen Link kopiert haben. Falls Sie über die Qualis Homepage zu dieser Seite gelangt sind, überprüfen Sie bitte, dass Sie die LSF Nummer und den Zugangscode richtig eingegeben haben.",
		},
		en: {
			title: "Error",
			content:
				"No questionnaire could be found with the data provided by you. If you accessed the questionnaire by a link, please make sure that you've copied the whole link. If you've accessed the questionnaire via the Qualis homepage, please make sure that you've entered the correct LSF number and access code.",
		},
	};
}

export default MSG;
